import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule } from "@angular/router";
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { GestureConfig } from "@angular/material/core";
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
} from "ngx-perfect-scrollbar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort, Sort } from "@angular/material/sort";

import { rootRouterConfig } from "./app.routing";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";

import { HttpClient, HttpClientModule } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CoreModule } from "./core/core.module";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { SharedMaterialModule } from "./shared/shared-material.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { environment } from "environments/environment";
import { AngularFireModule } from "@angular/fire";
import { AngularFireDatabaseModule } from "@angular/fire/database";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BillingManagementComponent } from "./modules/admin/billing-management/billing-management.component";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { EnquiryComponent } from './modules/admin/enquiry/enquiry.component';

// import { DealerDetailsComponent } from './modules/admin/dealer-details/dealer-details.component';

const firebase = environment.firebaseConfig;

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

const routerOptions:ExtraOptions = {
  anchorScrolling :'enabled',
  useHash:false

}

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    CoreModule,
    HttpClientModule,
    PerfectScrollbarModule,
    MatTooltipModule,
    MatIconModule,
    MatSortModule,
    MatPaginatorModule,
    SharedMaterialModule,
    CarouselModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(firebase),

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // InMemoryWebApiModule.forRoot(InMemoryDataService, { passThruUnknownUrl: true}),
    RouterModule.forRoot(rootRouterConfig, routerOptions),
    NgbModule,
  ],
  declarations: [AppComponent],
  providers: [
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    // {provide:LocationStrategy,useClass:HashLocationStrategy}


  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
